// extracted by css-extract-rspack-plugin
export default {"infoCardWrapper":"appointmentPreview_infoCardWrapper__ZDyy4","divider":"appointmentPreview_divider__sapog","hist":"appointmentPreview_hist__e7beD"};